module.exports = __webpack_public_path__ + "img/logo-new3.deab4d2d.png";